import { render, staticRenderFns } from "./newsPage.vue?vue&type=template&id=4929bf84&scoped=true&"
import script from "./newsPage.vue?vue&type=script&lang=js&"
export * from "./newsPage.vue?vue&type=script&lang=js&"
import style0 from "./newsPage.vue?vue&type=style&index=0&id=4929bf84&lang=scss&scoped=true&"
import style1 from "./newsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4929bf84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
